module.exports = __webpack_public_path__ + "static/media/artist-in-grand-hall-flipped.2d68eaa2.jpg";